import React, { useEffect } from 'react';
import './task-history.scss';
import ProcessConfigTable from '../../shared/components/process-config-table/process-config-table';

const RecordingList = () => {
	useEffect(() => {
		document.title = 'Roxus | Setting List';
	}, []);

	return (
		<div className='ocr-list-page'>
			<div className='ocr-title'>
				<span className='text'>PROCESS CONFIG</span>
			</div>
			<ProcessConfigTable />
		</div>
	);
};

export default RecordingList;
